<section class="{{ type() }} {{ color() }}">
  @switch (type()) {
    @case ('top') {
      <h3 class="subtitle" [innerHTML]="title()"></h3>
      @if (guidance()) {
        <p [innerHTML]="guidance()"></p>
      }
    }
    @case ('bottom') {
      <div class="icon-title-text">
        @if (showIcon()) {
          <div class="icon">
            <img class="exclamation-icon" src="{{ pcIcon.ERROR_ICON }}" alt="test" />
          </div>
        }
        <div class="text-content body-small">
          <span class="title" [innerHTML]="title()"></span>
          <span class="description" [innerHTML]="guidance()"></span>
        </div>
      </div>
    }
  }
</section>
